import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/(schedule-appointment)/[department]/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/components/move-to-top/move-to-top.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/components/schedule-header/schedule-header.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/[lng]/(schedule-appointment)/[department]/layout.tsx\",\"import\":\"Manrope\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\"]}],\"variableName\":\"manrope_font\"}");
